import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import { AiModelTab } from './aiModelConfig/AiModelTab';
import { isProjectReadOnly } from '../../common/utils/api_utils';

export class AiModelSection extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    activeModelType: 'OPEN_AI',
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  switchAIModelTypeTab = (tab) => {
    const { activeModelType } = this.state;
    if (activeModelType !== tab) {
      this.setState({ activeModelType: tab });
    }
  };

  render() {
    const { appSetting, match, actions } = this.props;
    const { projectDetail } = appSetting;
    const { projectId, version } = match.params;
    if (!projectDetail) {
      return '';
    }
    const { environments } = projectDetail;
    const isReadOnly = isProjectReadOnly(projectId);
    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'aiModelConfig'} projectDetail={projectDetail} />
        <AiModelTab
          projectDetail={projectDetail}
          environments={environments}
          projectId={projectId}
          version={version}
          updateAiModelConfig={actions.updateAiModelConfig}
          activeModelType={this.state.activeModelType}
          switchAIModelTypeTab={this.switchAIModelTypeTab}
          isReadOnly={isReadOnly}
        />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AiModelSection);
